<template>
  <div>
    <main>
      <div class="wide-wrapper">
        <h2>Contrology<sup>®</sup> Wunda Chair</h2>
        <!-- <h3></h3> -->

        <div class="upper-content-wrapper">
          <photo-grid :feature="featureImgHtml" @openModal="openModal" @isVideo="initModal">
            <photo
              @setFeature="setFeatureImg"
              @isVideo="initModal"
              src="Wunda Chair_Contrology_Video_Thumb@1x.jpg"
              src2="Wunda Chair_Contrology_Video_Thumb@2x.jpg"
              alt="Photo of Contrology Wunda Chair"
              video
            />
            <photo
              @setFeature="setFeatureImg"
              src="contrology-wundachair1@1x.jpg"
              src2="contrology-wundachair1@2x.jpg"
              alt="Photo of Contrology Wunda Chair"
            />
            <photo
              @setFeature="setFeatureImg"
              src="contrology-wundachair2@1x.jpg"
              src2="contrology-wundachair2@2x.jpg"
              alt="Side view photo of Contrology Wunda Chair"
            />
            <photo
              @setFeature="setFeatureImg"
              src="contrology-wundachair3@1x.jpg"
              src2="contrology-wundachair3@2x.jpg"
              alt="Front view of Contrology Wunda Chair"
            />
            <photo
              @setFeature="setFeatureImg"
              src="contrology-wundachair4@1x.jpg"
              src2="contrology-wundachair4@2x.jpg"
              alt="Detail photo of Contrology Wunda Chair"
            />
            <photo
              @setFeature="setFeatureImg"
              src="contrology-wundachair5@1x.jpg"
              src2="contrology-wundachair5@2x.jpg"
              alt="Detail photo of Contrology Wunda Chair"
            />
            <!-- <photo
              @setFeature="setFeatureImg"
              src="contrology-wundachair6@1x.jpg"
              src2="contrology-wundachair6@2x.jpg"
              alt="Detail photo of Contrology Wunda Chair"
            /> -->
          </photo-grid>

          <!-- <cta-button class="cta-button wide" /> -->

          <div class="content-wrapper">
            <section class="intro">
              <h2>Contrology<sup>®</sup> Wunda Chair</h2>
              <!-- <h3></h3> -->
              <p>
                The Contrology® Wunda Chair is a precise recreation of the original Wunda Chair first designed by Joseph Pilates and brought to light by Kathy Stanford Grant.
                <span
                  v-show="!show"
                  class="content-link"
                  @click="toggleContent"
                  role="button"
                  tabindex="0"
                >
                  More ›
                </span>
              </p>
              <div v-show="show">
                <p>Balanced Body took exact, painstaking measurements from Chairs previously owned by Kathy and made by Joe, who used the same style of chair in his own studio. The result is a near perfect reproduction of the exact resistance and geometry of the original Wunda Chair.</p>
                <p>The Chair's padded non-slip pedal is lighter than most pedals yet incredibly sturdy. In addition, the pedal's “mushroom shape” also allows users to wrap their fingers around the pedal pad. This keeps the wrist long and allows for a better connection in the back and center.</p>
                <p>The Contrology® Wunda Chair is an incredibly effective tool for building upper body, lower body and core strength. For this reason, the chair can be used for athletic training and improving sports performance. In addition, the Wunda Chair has a small physical footprint, which makes it ideal for studios and homes where space is at a premium!
                  <span
                    v-show="show"
                    class="content-link"
                    @click="toggleContent"
                    role="button"
                    tabindex="0"
                  >
                    Less ›
                  </span>
                </p>
              </div>
            </section>

            <product-selector
              :products=products
              :product=product
              :option1=option1
              :option2=option2
              :isdistcountry=isdistcountry
              :fsahsa="true"
              additionalText="19-day lead time"
            />

            <!-- Patent info -->
            <p class="part-number patent-info">
              <a href="https://www.pilates.com/company/balanced-body-patent-data">Click here</a> for <span style="font-weight: 500;">Balanced Body Patent Data</span>.
            </p>

            <section class="links">
              <icon-link
                url="https://www.pilates.com/store/returns-and-warranty"
                img="icon-warranty.svg"
                alt="Warranty icon"
                title="Learn more"
              >Limited 10-Year Warranty</icon-link>
              <icon-link
                url="support"
                img="icon-assembly.svg"
                alt="Assembly icon"
                title="Learn more"
              >Assembly &amp; Support</icon-link>
              <icon-link
                img="icon-upholstery.svg"
                alt="Upholstery icon"
              >Stock Upholstery: Black</icon-link>
              <icon-link
                img="icon-upholstery-colors.svg"
                alt="Color upholstery icon"
                title="Open modal"
                url="#"
                @open="showCardModal = true"
              >Upholstery Options</icon-link>
              <icon-link
                url="#accessories"
                title="See the accessories"
                img="icon-accessories.svg"
                alt="Accessories icon"
              >Accessories</icon-link>
            </section>

            <modal-card-large v-if="showCardModal" @close="showCardModal = false" />

            <!-- <cta-button class="cta-button" /> -->
          </div>
        </div>

        <section class="product-info">
          <prod-accordion class="accordion-wrapper" title="Features" animation="reveal">
            <ul class="features">
              <li>Durable blockboard with premium poplar laminate finish</li>
              <li>Spiral spring attachment makes it really easy to hook and release the springs</li>
              <li>Classically designed and sized &mdash; from frame to pedal</li>
              <li>Mushroom shaped single, padded, non-slip step</li>
              <li>Thin foam padding provides feedback while sitting or standing on the Chair</li>
              <li>Stock upholstery: Please call us at 916-388-2838 or <a href="mailto:info@pilates.com">email us</a> to order custom colors</li>
            </ul>
          </prod-accordion>
          <prod-accordion class="accordion-wrapper" title="Dimensions" animation="reveal">
            <p>H: 23.25” (59 cm)</p>
            <p>Side-to-Side: 30” (76cm)</p>
            <p>W: 21.25” (54cm)</p>
            <p>Weight: 49lbs (22.2kg)</p>
            <p>Seat Length and Width: 14 3/4" x 21 1/4" (38cm x 54cm)</p>
          </prod-accordion>

          <tabs>
            <tab name="Features" :selected="true">
              <ul class="features">
                <li>Durable blockboard with premium poplar laminate finish</li>
                <li>Spiral spring attachment makes it really easy to hook and release the springs</li>
                <li>Classically designed and sized &mdash; from frame to pedal</li>
                <li>Mushroom shaped single, padded, non-slip step</li>
                <li>Thin foam padding provides feedback while sitting or standing on the Chair</li>
                <li>Stock upholstery: Please call us at 916-388-2838 or <a href="mailto:info@pilates.com">email us</a> to order custom colors</li>
              </ul>
            </tab>
            <tab name="Dimensions" class="dims" style="margin-left: 5px;">
              <p>H: 23.25” (59 cm)</p>
              <p>L: 30” (76cm)</p>
              <p>W: 21.25” (54cm)</p>
              <p>Weight: 49lbs (22.2kg)</p>
              <p>Seat Length and Width: 14 3/4" x 21 1/4" (91cm x 134cm)</p>
            </tab>
          </tabs>
        </section>
      </div>

      <testimonial
        src="quotebanner-wundachair@1x.jpg"
        src2="quotebanner-wundachair@2x.jpg"
        alt="Photo of woman on a Wunda Chair"
      >
        “This chair really is a wunda! It will take your Pilates practice to a whole new level.”
        <span>~Jay Grimes</span>
      </testimonial>
    </main>
    <Modal v-if="showModal" @close="showModal = false">
      <div slot="header"></div>
      <div slot="body">
        <div class="embed-container">
          <iframe title="This is an embedded iframe video" src="https://www.youtube.com/embed/SkemC8G3wZ4?autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        </div>
      </div>
      <div slot="footer"></div>
    </Modal>
  </div>
</template>

<script>
import PhotoGrid from "@/components/PhotoGrid.vue";
import Photo from "@/components/Photo.vue";
import ProductSelector from "@/components/ProductSelector.vue";
import IconLink from "@/components/IconLink.vue";
import ModalCardLarge from "@/components/ModalCardLarge.vue";
// import CtaButton from "@/components/CtaButton.vue";
import ProdAccordion from "@/components/ProdAccordion.vue";
import Tabs from "@/components/Tabs.vue";
import Tab from "@/components/Tab.vue";
import Testimonial from "@/components/Testimonial.vue";
import Modal from "@/components/Modal.vue";

export default {
  name: "ladderbarrel",

  metaInfo: {
    title: "Classical Pilates Chair - Wunda Chair - Contrology Chair",
    titleTemplate: "%s",
    meta: [
      {
        name: "description",
        content: "The Wunda Chair is a precise re-creation of the original Wunda Chair first designed by Joseph Pilates. Come see why this Pilates Chair is such an effective tool."
      }
    ]
  },

  components: {
    PhotoGrid,
    Photo,
    ProductSelector,
    IconLink,
    ModalCardLarge,
    // CtaButton,
    ProdAccordion,
    Tabs,
    Tab,
    Testimonial,
    Modal
  },

  props: {
    isdistcountry: Boolean
  },

  data() {
    return {
      featureImgHtml: "", // PhotoGrid
      showCardModal: false, // ModalCard
      show: false, // Intro content
      modalExists: false, // Check featured image for video
      showModal: false, // Video modal in photogrid
      product: {
        label: "Select a Wunda Chair",
        value: "",
        key: "name"
      },
      option1: {
        label: "Select a Color",
        value: "",
        key: "color"
      },
      option2: {},
      products: [
        // Product options
        {
          prodid: 42132028260545,
          partnumber: 18139,
          price: 1150,
          name: "Contrology Wunda Chair",
          color: "Black Upholstery",
          available: true
        },
        {
          prodid: 42132028293313,
          partnumber: "18139C",
          price: "1150",
          name: "Contrology Wunda Chair",
          color: "Adobe White Upholstery",
          available: true
        },
        {
          prodid: 42132028326081,
          partnumber: "18139C",
          price: "1150",
          name: "Contrology Wunda Chair",
          color: "Burgundy Upholstery",
          available: true
        },
        {
          prodid: 42132028358849,
          partnumber: "18139C",
          price: "1150",
          name: "Contrology Wunda Chair",
          color: "Dark Cherry Upholstery",
          available: true
        },
        {
          prodid: 42132028391617,
          partnumber: "18139C",
          price: "1150",
          name: "Contrology Wunda Chair",
          color: "Greystone Upholstery",
          available: true
        },
        {
          prodid: 42132028424385,
          partnumber: "18139C",
          price: "1150",
          name: "Contrology Wunda Chair",
          color: "Oak Upholstery",
          available: true
        },
        {
          prodid: 42132028457153,
          partnumber: "18139C",
          price: "1150",
          name: "Contrology Wunda Chair",
          color: "Sage Upholstery",
          available: true
        },
        {
          prodid: 42132028489921,
          partnumber: "18139C",
          price: "1150",
          name: "Contrology Wunda Chair",
          color: "Storm Upholstery",
          available: true
        },
        {
          prodid: 42132028522689,
          partnumber: "18139C",
          price: "1150",
          name: "Contrology Wunda Chair",
          color: "Wedgewood Upholstery",
          available: true
        }
      ]
    };
  },

  methods: {
    // Set PhotoGrid featured image
    setFeatureImg(html) {
      this.featureImgHtml = html;
    },

    // Toggle intro content
    toggleContent() {
      this.show = !this.show;
    },

    // Does featured image include a video?
    initModal() {
      this.modalExists = true;
    },

    // Open modal from featured image
    openModal() {
      if ( this.modalExists ) {
        this.showModal = true;
        this.modalExists = false // Reset prop
      }
    }
  }
};
</script>

<style lang="scss" scoped>
h2 {
  text-align: center;
  margin: 0;
  padding: 0;
}

h2 + h3 {
  display: none;
}

.intro h2 {
  display: none;
}

.intro h3 {
  display: block;
}

.intro p {
  font-family: var(--roboto);
  font-size: 0.9375rem;
  line-height: 1.467;
  color: #333;
}

.content-link {
  text-decoration: underline;
  cursor: pointer;
  color: #000;
}

.wide {
  display: none;
}

.links {
  margin-top: 30px;
}

.product-info {
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
  border-bottom: 1px solid #010101;
  margin-top: 30px;
}

ul {
  margin: 0;
  padding: 0;
  list-style: none;
  font-family: var(--roboto);
  font-size: 0.875rem;
  line-height: 1.214;
  color: #333;
}

.features li {
  background: url("https://s3.amazonaws.com/s3.pilates.com/contrology/icon-check-basic.svg")
    no-repeat left center;
  padding-left: 20px;
}

.included li {
  background: url("https://s3.amazonaws.com/s3.pilates.com/contrology/icon-check-feature.svg")
    no-repeat left center;
  padding-left: 40px;
}

li {
  border-bottom: 1px solid #c4c4c4;
  padding-top: 10px;
  padding-bottom: 10px;
}

li:last-of-type {
  border-bottom: none;
}

.accordion-wrapper p {
  margin-left: 30px;
}

.tabs-wrapper {
  display: none;
}

.accessories-wrapper {
  margin-top: 30px;
}

.accessories-wrapper h2 {
  margin: 2.5rem 0 1.5rem;
}

.accessories {
  display: flex;
  flex-flow: row wrap;
  justify-content: center;
}

.patent-info {
  -webkit-box-ordinal-group: 3;
  -ms-flex-order: 3;
  order: 3;
  font-family: var(--roboto);
  font-size: 0.75rem;
  line-height: 1.25;
  color: var(--black);
  margin-bottom: 12px;
}
.embed-container {
  position: relative;
  padding-bottom: 56.25%;
  height: 0;
  overflow: hidden;
  max-width: 100%;
}

.embed-container iframe,
.embed-container object,
.embed-container embed { 
  position: absolute; 
  top: 0; 
  left: 0; 
  width: 100%; 
  height: 100%; 
}

@media only screen and (min-width: 768px) {
  h2 + h3 {
    display: block;
    margin: 0;
  }

  .intro h3 {
    display: none;
  }

  .upper-content-wrapper {
    padding: 0 80px;
  }

  .content-wrapper {
    max-width: 530px;
    margin: 0 auto;
  }

  .links {
    column-count: 3;
    position: relative;
    margin-top: 15px;
  }

  .links > * {
    -webkit-column-break-inside: avoid;
    page-break-inside: avoid;
    break-inside: avoid;
  }

  .icon-link {
    margin-top: 0;
  }

  ::v-deep .modal-card-wrapper {
    position: absolute;
    top: 130%;
    left: 10%;
    width: 80%;
    margin: 0 auto;
  }

  .tabs-wrapper {
    display: block;
    max-width: 810px;
    margin: auto auto 50px;
  }

  .dims {
    max-width: 650px;
    margin: 0 auto;
  }

  .dims table {
    border-collapse: collapse;
    font-family: "Roboto", Helvetica, Arial, sans-serif;
    line-height: 1.25;
    color: #000;
    font-size: 0.75em;
    margin: 13px auto 0;
  }

  .dims th,
  .dims td {
    text-align: left;
    width: 20%;
    padding: 5px 10px;
    border: 1px solid #c4c4c4;
  }

  .dims td {
    height: 50px;
  }

  .dims tr th:first-of-type,
  .dims tr td:first-of-type {
    background-color: rgba(255, 255, 255, 0.5);
  }

  .product-info {
    border: none;
    box-shadow: none;
  }

  li:last-of-type {
    border-bottom: 1px solid #c4c4c4;
  }

  .accordion-wrapper {
    display: none;
  }

  .accessories {
    flex-flow: row nowrap;
  }
}

@media only screen and (min-width: 1024px) {
  .upper-content-wrapper {
    padding: 0 45px;
    display: flex;
    align-items: flex-start;
    max-width: 900px;
    margin: 0 auto 30px;
  }

  .content-wrapper {
    width: 340px;
    display: flex;
    flex-flow: column nowrap;
  }

  .intro {
    order: 1;
    margin-top: 15px;
  }

  .cta-button {
    order: 3;
    margin: 0;
  }

  .links {
    column-count: 1;
    order: 4;
  }

  ::v-deep .modal-card-wrapper {
    top: 85%;
  }

  .icon-link {
    margin: 0;
  }
}

@media only screen and (min-width: 1208px) {
  .wide-wrapper {
    background-color: rgba(255, 255, 255, 0.75);
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: auto auto auto auto;
    position: relative;
    z-index: 0;
    max-width: 1050px;
    margin: 0 auto;
  }

  .upper-content-wrapper {
    display: contents;
  }

  .photo-grid-wrapper {
    grid-column: 1 / span 1;
    grid-row: 1 / span 2;
  }

  .content-wrapper {
    width: auto;
    grid-column: 2 / span 1;
    grid-row: 1 / span 1;
    margin: 50px 30px 20px 0;
    max-width: 600px;
  }

  .product-info {
    grid-column: 2 / span 1;
    grid-row: 2 / span 3;
    margin-right: 30px;
    margin-top: 5px;
    max-width: 512px;
  }

  .cta-button {
    display: none;
  }

  .cta-button.wide {
    display: flex;
    grid-column: 1 / span 1;
    grid-row: 3 / span 1;
    justify-self: center;
    margin: 0 80px 30px auto;
  }

  .intro h2,
  .intro h3 {
    display: block;
    text-align: left;
  }

  .wide-wrapper > h2,
  .wide-wrapper > h3 {
    display: none;
  }

  .links {
    column-count: 2;
    max-width: 400px;
  }

  ::v-deep .modal-card-wrapper {
    top: 40%;
  }

  .icon-link {
    margin: 1px;
    height: 27px;
  }

  ::v-deep .tabs-details {
    background-color: transparent;
    padding: 10px 0 0;
  }
}
</style>
